import React, { useRef, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { filteredRow } from "../../../utils/dataTransformer";
import AgGrid from "../../Table/AgGrid";

const ManufacturePermission = ({ columnDefs, priviledgeList, resource }) => {
  const gridRef = useRef();
  const { t } = useTranslation();

  const useFilteredRows = useCallback(() => {
    const rows = [
      {
        functionName: "BOM",
        name: t("manufacture.bom.index"),
        view: "view",
        create: "create",
        edit: "edit",
        delete: "delete",
      },
      {
        functionName: "ORDER",
        name: t("manufacture.order.index"),
        view: "view",
        create: "create",
        edit: "edit",
        cancel: "cancel",
      },
      {
        functionName: "WORK_ORDER",
        name: t("manufacture.workOrder.index"),
        view: "view",
        create: "create",
        edit: "edit",
        cancel: "cancel",
      },
      {
        functionName: "REPORT",
        name: t("report"),
        view: "view",
      },
    ];
    return filteredRow(rows, priviledgeList, resource);
  }, [priviledgeList, resource, t]);

  return (
    <AgGrid
      rowData={useFilteredRows()}
      ref={gridRef}
      columnDefs={columnDefs}
      autoHeight
      isClientSide
    />
  );
};

export default ManufacturePermission;
